export enum VideoProvider {
  ZoomLink = 'zoom_link',
  ZoomEmbedded = 'zoom_embedded',
  Tokbox = 'tokbox',
}
